import React from 'react';
import {
  CORE_SIDEBAR_COMPONENT_CONFIG,
  CORE_SIDEBAR_ITEMS,
} from '../../core/config/sidebar/sidebar.config';
import {
  ERP_SIDEBAR_COMPONENT_CONFIG,
  ERP_SIDEBAR_ITEMS,
} from '../../erp/config/sidebar/sidebar.config';

export const companySidebarItems = [
  {
    title: 'SIDEBAR.GROUP_COMPANY_MANAGEMENT',
    items: [
      ...(CORE_SIDEBAR_ITEMS.company ?? []),
      ...(ERP_SIDEBAR_ITEMS.company ?? []),
    ],
  },
];

export const sidebarItems = [
  {
    title: 'SIDEBAR.GROUP_GENERAL',
    items: [
      ...(CORE_SIDEBAR_ITEMS.general ?? []),
      ...(ERP_SIDEBAR_ITEMS.general ?? []),
    ],
  },
  {
    title: 'SIDEBAR.GROUP_SETTINGS',
    items: [
      ...(ERP_SIDEBAR_ITEMS.settings ?? []),
      ...(CORE_SIDEBAR_ITEMS.settings ?? []),
    ],
  },
];

export const sidebarComponentConfig = {
  component: (
    <>
      {CORE_SIDEBAR_COMPONENT_CONFIG.component}
      {ERP_SIDEBAR_COMPONENT_CONFIG.component}
    </>
  ),
};
